export default __webpack_public_path__ + "static/media/tailgating.c05fa493.png";